import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReportUserService } from 'app/services/report-user.service';

@Component({
  selector: 'app-report-company-app',
  templateUrl: './report-company-app.component.html',
  styleUrls: ['./report-company-app.component.css']
})
export class ReportCompanyAppComponent implements OnInit {

  @Output() infoReport = new EventEmitter<string>();
  @Output() showInfo = new EventEmitter<boolean>();

  showUsers: boolean;
  showReport: boolean;
  report;
  showReportCompanyApp: boolean;

  constructor(private reportService: ReportUserService, private translate: TranslateService) { }

  ngOnInit() {

  }

  openDialog(reportType) {
    this.infoReport.emit(this.translate.instant(`report.${reportType}`));
    this.showInfo.emit(true);
  }

  reportCompanyApplication() {
    this.showReport = false;
    this.reportService.getReportCompanyApp(this.showUsers).subscribe(res=> {
      this.showReport = true;
      this.report = res;
      this.showReportCompanyApp = true;
    });
  }

  closeDialogReport() {
    this.showReport = false;
    this.showReportCompanyApp = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/report-company-app/report-company-app.component.ts